import { AcAppHeader, AcCard, AcTypography, AcAccordion, AcAccordionItem, AcButton, AcLoader } from '@components'
import { LABELS, ROUTE_PATHS } from '@constants'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useStore } from '@hooks/use-store'

export const AcSystemFailedJobDetail = observer(() => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { failed_jobs } = useStore()

  useEffect(() => {
    if (id) failed_jobs.getFailedJob(id)
    return () => { failed_jobs.failed_job = null }
  }, [id])

  const data = failed_jobs.watch_failed_job
  const job = useMemo(() => data?.job ?? data ?? {}, [data])
  const exception = useMemo(() => data?.exception ?? {}, [data])

  const handleRetry = async () => {
    if (!id) return
    try {
      await failed_jobs.retryFailedJob(id)
      // After retry, go back to system overview; failed job might be gone
      navigate(ROUTE_PATHS.SYSTEM_SETTINGS)
    } catch (e) {
      // Basic fallback: stay; in real app we might show a toast
    }
  }

  return (
    <>
      <AcAppHeader title={`Failed Job ${id}`} showBackButton />
      <AcCard>
        {failed_jobs.is_loading ? (
          <AcLoader />
        ) : data ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <AcCard>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <AcTypography weight="semibold">Failed Job</AcTypography>
                <AcButton onClick={handleRetry} disabled={failed_jobs.is_retrying_failed_job} label="Retry" />
              </div>
              <AcAccordion>
                <AcAccordionItem title="Job Data">
                  <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(job, null, 2)}</pre>
                </AcAccordionItem>
                <AcAccordionItem title="Exception">
                  <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(exception, null, 2)}</pre>
                </AcAccordionItem>
              </AcAccordion>
            </AcCard>
            <AcCard>
              <AcTypography weight="semibold">Overview</AcTypography>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
                <div><AcTypography weight="semibold">Queue:</AcTypography> <AcTypography element="span" size="sm">{String(job?.queue ?? job?.connection ?? '-')}</AcTypography></div>
                <div><AcTypography weight="semibold">Attempts:</AcTypography> <AcTypography element="span" size="sm">{String(job?.attempts ?? job?.tries ?? job?.attempt ?? '-')}</AcTypography></div>
                <div><AcTypography weight="semibold">Failed at:</AcTypography> <AcTypography element="span" size="sm">{String(job?.failed_at ?? job?.finished_at ?? '-')}</AcTypography></div>
              </div>
            </AcCard>
          </div>
        ) : (
          <AcTypography>-</AcTypography>
        )}
      </AcCard>
    </>
  )
})
